import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import {
  InlineContainer,
  MJMLogo,
  NavigationContainer,
  TopNavIcon,
} from '../../styled-components/GlobalStyledComponents';
import useDetectResize from '../../hooks/useDetectResize';
import Logo from '../../assets/images/new-logo-lrg.svg';
import { hasUnreadNotifications } from '../../store/slices/notificationSlice';
import { useSelector } from 'react-redux';
import Icon from '../../assets/icons/icons';
import Modal from '../UI/Popup/BackdropComponent';
import NotificationComponent from '../NotificationComponent/NotificationComponent';
import CloseIcon from '@mui/icons-material/Close';
import { ProfileIconWrapper } from '../../styled-components/NavigationStyledComponents';
import {
  LogoutOverlay,
  NotificationOverlay,
} from '../../styled-components/NotificationModalStyledComponents';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { ProfileAndLogoutComponent } from '../NavigationComponents/MobileNavigationComponent';
import { MobileNavProps } from '../../types/interface';
import { useAppSelector } from '../../store/store';
import { rtkFetchUserInfo } from '../../store/slices/individualSlice';

const MobileHeaderComponent = (props: MobileNavProps) => {
  const { browserWindow } = useDetectResize();
  const myDetails = useAppSelector(rtkFetchUserInfo);
  //Create reusable component here.
  const unreadNotifications = useSelector(hasUnreadNotifications);
  const [dropDownNotification, setDropDownNotification] = useState<boolean>(false);
  const [dropDownProfile, setDropDownProfile] = useState<boolean>(false);
  const { theme, colorMode, isNavMenu } = props;

  const DisplayAccountMenuIcon = () => {
    return (
      <>
        {myDetails?.profileImg!.startsWith('https://') ? (
          //SET AVATAR
          <img
            className={`profile-img-header`}
            src={myDetails?.profileImg!}
            alt="headshot"
            loading="lazy"
            style={{
              width: '35px !important',
              height: 'auto',
              justifyContent: 'center',
              backgroundColor: 'white',
              borderRadius: '50%',
            }}
          />
        ) : (
          <AccountCircleIcon fontSize="large" color="primary" />
        )}
      </>
    );
  };

  return (
    <NavigationContainer height={browserWindow.h}>
      <InlineContainer justifyContent="space-between" alignItems="stretch">
        <Button
          variant="outlined"
          sx={{
            height: 'initial !important',
            minWidth: '75px',
            borderRadius: '10px',
            padding: '5px 15px',
            maxHeight: '40px',
          }}
          className="nav-button"
          onClick={props.onToggleNavigation}
        >
          {isNavMenu ? <CloseIcon /> : 'MENU'}
        </Button>

        <Box sx={{ width: '200px', display: 'flex' }}>
          <MJMLogo src={Logo} alt="nav-logo" />
        </Box>

        {isNavMenu ? (
          <ProfileIconWrapper
            className="bell-icon"
            onClick={() => {
              setDropDownProfile((state) => !state);
            }}
          >
            <DisplayAccountMenuIcon />
          </ProfileIconWrapper>
        ) : (
          <ProfileIconWrapper
            className="bell-icon"
            onClick={() => {
              setDropDownNotification((state) => !state);
              setDropDownProfile((state) => (state = false));
            }}
          >
            {unreadNotifications ? (
              <TopNavIcon src={Icon.YesNot} alt="unread-notification" />
            ) : (
              <TopNavIcon src={Icon.NoNot} alt="read-notifications" />
            )}
          </ProfileIconWrapper>
        )}
      </InlineContainer>
      {dropDownNotification && (
        <Modal
          onHide={() => {
            setDropDownNotification(false);
          }}
          extraStyling="modal-header-positioning"
        >
          <NotificationOverlay
            className={`modal-overlay-wrapper`}
            onClick={(e: any) => {
              e.stopPropagation();
            }}
            top={browserWindow.h}
            right={browserWindow.w}
          >
            <NotificationComponent
              closeModal={() => {
                setDropDownNotification(false);
              }}
            />
          </NotificationOverlay>
        </Modal>
      )}
      {dropDownProfile && (
        <Modal
          onHide={() => {
            setDropDownProfile(false);
          }}
          extraStyling="modal-header-positioning"
        >
          <LogoutOverlay
            className={`modal-overlay-wrapper`}
            onClick={(e) => {
              setDropDownProfile(false);
              e.stopPropagation();
            }}
            top={browserWindow.h}
            right={browserWindow.w}
          >
            <ProfileAndLogoutComponent />
          </LogoutOverlay>
        </Modal>
      )}
    </NavigationContainer>
  );
};

export default MobileHeaderComponent;
